//Libraries
import React from "react";
import { connect } from "react-redux";

// Local Libraries
import phrasebookLoad from "../../i18n";
import * as token from '../../helpers/token';
import { accountTypesConstants, portalFunctionalityConstants, permissionTypeConst } from '../../constants';
import { capitalizeFirstLetter, permissionFinder } from "../../helpers/util"


//Redux
import { notificationActions } from 'actions';

//Componenets
import { Table } from "../../components/SkyFramework/Tables/Table.jsx";
import { PaginationBar } from "../../components/SkyFramework/Pagination/PaginationBar.jsx";
import { NewBreadcrumbs } from "../../components/SkyFramework/Breadcrumbs/NewBreadcrumbs";
import { SearchBox } from "../../components/SkyFramework/Search";

//Routes
import { gisRoutes } from "../../routes/routes";

// Constants
const phrasebook = phrasebookLoad()

class Notification extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      notification: undefined,
    };

    this.account_type_logged = accountTypesConstants[token.loggedAccountType()];
    // this.handleSearchSubmit = this.handleSearchSubmit.bind(this);
    // this.handleChange = this.handleChange.bind(this);
    // this.handleDeleteSubmit = this.handleDeleteSubmit.bind(this);
  }

  componentDidMount() {
    this.props.dispatch(notificationActions.get(this.props.match.params.id));
  }

  componentDidUpdate(prevProps) {
    if (this.props.notifications && prevProps && prevProps.notifications !== this.props.notifications) {
      this.setState({ notification: this.props.notification });
    }
  }

  render = () => {
    const { notification } = this.props;
    if (notification) {
      this.state.notification = notification;
      return <>
        <NewBreadcrumbs crumbs={[{ link: gisRoutes.dashboard[this.account_type_logged], label: phrasebook.common.home }, { link: gisRoutes.notification.notification.list, label: phrasebook.notifications.notifications }]} current={phrasebook.notifications.message} />

        <div className="box px-1  pt-1 px-sm-2 pt-sm-2 pb-sm-1 mb-1">

          <div className="row">
            <div className="mb-1">
              <label className="d-label">
                <strong>Customer</strong>
              </label>
              <span className="pl-h">
                {this.state.notification.creator_customer ? this.state.notification.creator_customer.name : null}
              </span>
            </div>
          </div>
          <div className="row">
            <div className="mb-1">
              <label className="d-label">
                <strong>Notification Type</strong>
              </label>
              <span className="pl-h">
                {this.state.notification.notificationtype.functionality.category}
              </span>
              <span className="pl-h">
                {this.state.notification.notificationtype.functionality.sub_category}
              </span>
            </div>
          </div>
          <div className="row">
            <div className="mb-1">
              <label className="d-label">
                <strong>Status</strong>
              </label>
              <span className="pl-h">
                {this.state.notification.notification_status}
              </span>
            </div>
          </div>
          <div className="row">
            <div className="mb-1">
              <label className="d-label">
                <strong>Title</strong>
              </label>
              <span className="pl-h">
                {this.state.notification.notification_title}
              </span>
            </div>
          </div>
          <div className="row">
            <div className="mb-1">
              <label className="d-label">
                <strong>Message</strong>
              </label>
              <pre className="pl-h">
                <div dangerouslySetInnerHTML={{ __html: this.state.notification.notification_message }} />
              </pre>
            </div>
          </div>
        </div>
      </>
    } else return null
  }
}

function mapStateToProps(state) {
  const { authentication, notification } = state;
  const { authUser } = authentication;
  return {
    authUser,
    notification: notification.notification
  };
}

const notification = connect(mapStateToProps)(Notification);
export default notification;
